import React from 'react'
import { PropTypes } from 'prop-types'

class Search extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchTerms: this.props.value
    }
  }

  handleSearchTextChange = (event) => {
    if (event.target.value.length <= 100) {
      this.setState({ searchTerms: event.target.value })
    }
  }

  handleSearchClear = () => {
    this.setState({ searchTerms: '' })
    this.props.doSearch('')
  }

  handleSearchSubmit = () => {
    this.props.doSearch(this.state.searchTerms)
  }

  handleSearchOnKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleSearchSubmit()
    }
  }

  render() {
    return (
      <div className="ln-c-form-group ln-u-flush-bottom">
        <label htmlFor="generic-search-input" className="ln-c-label">
          {this.props.searchLabel}
        </label>
        <div className="ln-c-input-group ln-c-input-group--has-action ln-c-input-group--has-button">
          <input
            id="generic-search-input"
            name="search"
            type="search"
            className="ln-c-text-input ln-c-input-group__control"
            placeholder={this.props.placeholderText}
            onChange={this.handleSearchTextChange}
            onKeyPress={this.handleSearchOnKeyPress}
            value={this.state.searchTerms}
          />
          { this.state.searchTerms !== '' &&
          <button aria-label="Clear the field" className="ln-c-button ln-c-input-group__action u-button--float" type="button" onClick={this.handleSearchClear}>
            <svg className="ln-c-icon" viewBox="0 0 24 24">
              <g stroke="none" fillRule="nonzero">
                <path d="M4.293 5.707L18.435 19.85a1 1 0 0 0 1.414-1.414L5.707 4.293a1 1 0 0 0-1.414 1.414z" />
                <path d="M18.435 4.293L4.293 18.435a1 1 0 0 0 1.414 1.414L19.85 5.707a1 1 0 1 0-1.414-1.414z" />
              </g>
            </svg>
          </button>
          }
          <button className="ln-c-button ln-c-button--primary ln-c-input-group__button" type="submit" onClick={this.handleSearchSubmit}>
            <svg className="ln-c-icon" viewBox="0 0 24 24">
              <g stroke="none" fillRule="nonzero">
                <path d="M23.207 21.793l-7.5-7.5a1 1 0 0 0-1.414 1.414l7.5 7.5a1 1 0 0 0 1.414-1.414z" />
                <path d="M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zm0 2A9 9 0 1 1 9 0a9 9 0 0 1 0 18z" />
              </g>
            </svg><span className="ln-u-visually-hidden">Search</span>
          </button>
        </div>
        <div>
          { this.state.searchTerms.length === 100 &&
            <span className="ln-u-color-red">The maximum search length of 100 characters has been reached.</span>
          }
        </div>
      </div>
    )
  }
}

Search.propTypes = {
  searchLabel: PropTypes.string.isRequired,
  doSearch: PropTypes.func.isRequired,
  placeholderText: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
}

Search.defaultProps = {
  searchLabel: '',
  placeholderText: ''
}

export default Search



// WEBPACK FOOTER //
// ./src/components/Search/index.jsx